import { useState, useEffect } from "react";
import { Card } from "@mui/material";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { boxStyle, buttonPosition, listDesign } from "../style/style";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteobj } from "../apicall/apicall";
import { useNavigate } from "react-router-dom";

import AddToQueueIcon from "@mui/icons-material/AddToQueue";

import {
  StyledTableRow,
  StyledTableCell,
  buttonStyle,
  Root,
  form_add2,
  buttonStyle2,
  headerStyle,
  form_add,
} from "../style/style";

import { getobj } from "../apicall/apicall";
import { postobj } from "../apicall/apicall";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { validated } from "../apicall/validateform";

const default_device = {
  device_type: "",
  device_name: "",
  model_number: "",
};

export default function AdminSetting() {
  const [device, setdevice] = useState({
    device_type: "",
    device_name: "",
    model_number: "",
  });
  const [opt, setopt] = useState();
  const [name, setdevice_name] = useState();
  const [group, setgroup] = useState();
  const [value, setvalue] = useState("1");
  const [addgroup, setaddgroup] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [loaded, setloaded] = useState(true);
  const [password, setpassword] = useState({
    old_password: "",
    new_password: "",
  });
  const [pwd2, setpwd2] = useState();
  const handleClick = () => {
    console.log(validated(name));
    if ((validated(name), name)) {
      const url = process.env.REACT_APP_ZEWA_URL + "device/device-name/";
      const d = postobj(url, name);
      d.then((res) => {
        if (res.status === 200) {
          return res;
        }
        throw new Error(res);
      })
        .then(function (res) {
          console.log(res);
          setdevice_name("");
          NotificationManager.success("Device Group Added Successfully", "Success", 2000);
          setaddgroup(false);
        })
        .catch(() => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Device Group already exists");
        });
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);


      NotificationManager.error("Please fill the form");
    }
  };
  const history = useNavigate();
  const handlepassword = (e) => {
    const { name, value } = e.target;
    setpassword({
      ...password,
      [name]: value,
    });
  };
  const handlePasswordChange = () => {
    if (validated(password)) {
      if (password.new_password !== password.old_password) {
        if (pwd2 === password.new_password) {
          const url = process.env.REACT_APP_ZEWA_URL + "user/reset-password/";
          const res = postobj(url, password);
          res.then(function (r) {
            if (r["Message"] === "Password changed successfully") {
              NotificationManager.remove(NotificationManager.listNotify[0]);

              NotificationManager.success("Password Changed.", "Success", 2000);
              // console.log(NotificationManager.listNotify);

              NotificationManager.remove(NotificationManager.listNotify[0]);
              sessionStorage.setItem("token", "");

              history({ pathname: "/" });
              window.location.reload(true);
            } else {
              NotificationManager.remove(NotificationManager.listNotify[0]);

              NotificationManager.error("Incorrect password", "Failed", 2000);
            }
          });
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Password did not match", "Failed", 2000);
        }
      } else {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "The new password can not be same as the old password"
        );
      }
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("Plase fill the form correctly");
    }
  };
  const reset = () => {
    setpassword({
      old_password: "",
      new_password: "",
    });
    setpwd2("");
  };
  useEffect(() => {
    const url = process.env.REACT_APP_ZEWA_URL + "device/device-name/";
    const d = getobj(url);
    d.then(function (res) {
      setopt(res);
      //console.log(res);
    });
    const getgroup = process.env.REACT_APP_ZEWA_URL + "device/addDeviceGroup/";
    const group = getobj(getgroup);
    group.then(function (res) {
      setgroup(res);
      setloaded(false);
    });
  }, [value, addgroup, refresh]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setdevice({
      ...device,
      [name]: value,
    });
    // console.log(device);
  };
  const tabChange = (value) => {
    setdevice(default_device);
    setdevice_name("");
    setaddgroup(false);
    setvalue(value);
  };
  const handleDelete = (url) => {
    const res = deleteobj(url);
    res.then((r) => {
      if (r["Message"] === "Deleted successfully") {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success("Successfully deleted.", "Deleted", 2000);
        setrefresh(!refresh);
      } else {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "Could not deletd as it is associated with devices.",
          "Failed",
          2000
        );
      }

      // console.log(r["Message"]);
    });
  };
  const handleSubmit = (e) => {
    if (validated(device)) {
      e.preventDefault();
      const url = process.env.REACT_APP_ZEWA_URL + "device/addDeviceGroup/";
      const d = postobj(url, device);
      d.then((res) => {
        if (res.status === 200) {
          return res;
        }
        throw new Error(res);
      })
        .then(function (res) {
          console.log(res);
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success("Device Model added successfully");
          setdevice(default_device);
          setaddgroup(false);
        })
        .catch(() => {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error("Model already exists");
        });
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error("Please fill the form correctly");
    }
  };

  return (
    <Root>
      <Root>
        <Box sx={boxStyle}>
          <Card sx={headerStyle}>Admin Setting</Card>
          <Card sx={{ marginTop: "15px" }}>
            <TabContext value={value}>
              <Box
                sx={{ borderBottom: 1, borderColor: "divider", background: "" }}
              >
                <TabList value={value}>
                  <Tab
                    label="Add Device Model"
                    value={"1"}
                    onClick={() => tabChange("1")}
                  />
                  <Tab
                    label="Change Password"
                    value={"2"}
                    onClick={() => tabChange("2")}
                  />
                  <Tab
                    label="Device Group"
                    value={"3"}
                    onClick={() => tabChange("3")}
                  />
                  <Tab
                    label="Hub Token"
                    value={"4"}
                    onClick={() => tabChange("4")}
                  />
                </TabList>
              </Box>
              <TabPanel value="1">
                {!addgroup && (
                  <Box
                    m={2}
                    //margin

                    sx={!addgroup && buttonPosition}
                  >
                    <Button
                      variant={!addgroup && "contained"}
                      color={!addgroup && "primary"}
                      startIcon={!addgroup && <AddToQueueIcon />}
                      onClick={() => {
                        setaddgroup(!addgroup);
                      }}
                    >
                      {!addgroup && "Add  device model"}
                    </Button>
                  </Box>
                )}
                {addgroup ? (
                  <Box>
                    <FormControl fullWidth>
                      <InputLabel>Select Device Type</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="type"
                        sx={form_add2}
                        value={device.device_type}
                        label="Select Device Type"
                        name="device_type"
                        onChange={handleChange}
                      >
                        <MenuItem value={"BLUETOOTH"}>
                          Bluetooth Device
                        </MenuItem>
                        <MenuItem value={"CELLULAR"}>Cellular Device</MenuItem>
                      </Select>

                      <TextField
                        select
                        name="device_name"
                        id="deviceName"
                        sx={form_add2}
                        variant="outlined"
                        label="Device Group"
                        value={device.device_name}
                        onChange={handleChange}
                      >
                        {opt &&
                          opt.map((i) => {
                            return <MenuItem value={i.id}>{i.name}</MenuItem>;
                          })}
                      </TextField>

                      <TextField
                        id="outlined-multiline-flexible"
                        name="model_number"
                        sx={form_add2}
                        label="Enter model number"
                        value={device.model_number}
                        onChange={handleChange}
                      />

                      <Box m={-1}>
                        <Button
                          color="primary"
                          variant="contained"
                          className="form__custom-button"
                          sx={buttonStyle}
                          type="submit"
                          onClick={handleSubmit}
                        >
                          ADD
                        </Button>
                        <Button
                          color="error"
                          variant="contained"
                          className="form__custom-button"
                          sx={buttonStyle}
                          type="submit"
                          onClick={() => {
                            setdevice(default_device);
                            setaddgroup(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </FormControl>
                  </Box>
                ) : (
                  <Box>
                    {loaded ? (
                      <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..." />
                    ) : (
                    
                      <TableContainer>
                        <Table aria-label="simple table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell>
                                <b>Device type</b>
                              </StyledTableCell>
                              <StyledTableCell>
                                <b>Device Group</b>
                              </StyledTableCell>
                              <StyledTableCell>
                                <b>Model Number</b>
                              </StyledTableCell>
                              <StyledTableCell></StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {group &&
                              group.map((group) => (
                                <StyledTableRow key={group.id}>
                                    {console.log(JSON.stringify(group.model_number))}
                                  <StyledTableCell>
                                    {group.device_type}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {group.device_name}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    {group.model_number}
                                  </StyledTableCell>
                                  <StyledTableCell>
                                    <Button
                                      startIcon={<DeleteIcon color="error" />}
                                      onClick={() => {
                                        const url =
                                          process.env.REACT_APP_ZEWA_URL +
                                          "device/delete-device-group/" +
                                          group.id +
                                          "/";
                                        handleDelete(url);
                                      }}
                                    />
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Box>
                )}
              </TabPanel>
              <TabPanel value="2">
                <FormControl fullWidth>
                  <TextField
                    name="old_password"
                    sx={form_add}
                    type="password"
                    label="Enter Old Password"
                    value={password.old_password}
                    onChange={handlepassword}
                  />
                  <TextField
                    name="new_password"
                    sx={form_add}
                    type="password"
                    label="Enter New Password"
                    value={password.new_password}
                    onChange={handlepassword}
                  />
                  <TextField
                    name="New Password"
                    sx={form_add}
                    type="password"
                    label="Re-enter New Password"
                    value={pwd2}
                    onChange={(e) => {
                      setpwd2(e.target.value);
                    }}
                  />
                  <Box m={-1}>
                    <Button
                      color="primary"
                      variant="contained"
                      className="form__custom-button"
                      sx={buttonStyle}
                      type="submit"
                      onClick={handlePasswordChange}
                    >
                      Change
                    </Button>
                    <Button
                      color="error"
                      variant="contained"
                      className="form__custom-button"
                      sx={buttonStyle}
                      type="submit"
                      onClick={reset}
                    >
                      Cancel
                    </Button>
                  </Box>
                </FormControl>
              </TabPanel>
              <TabPanel value="3">
                {!addgroup && (
                  <Box
                    m={2}
                    //margin
                    sx={!addgroup && buttonPosition}
                  >
                    <Button
                      variant={"contained"}
                      color={"primary"}
                      startIcon={<AddToQueueIcon />}
                      onClick={() => {
                        setaddgroup(!addgroup);
                      }}
                    >
                      {addgroup ? "Cancel" : "Add Device Group"}
                    </Button>
                  </Box>
                )}

                <Box sx={listDesign}>
                  {!addgroup ? (
                    <Box>
                      {loaded ? (
                        <img src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif" alt="loading..."/>
                      ) : (
                        <TableContainer>
                          <Table aria-label="simple table">
                            <TableHead>
                              <TableRow>
                                <StyledTableCell>
                                  <b>Device Group</b>
                                </StyledTableCell>
                                <StyledTableCell>
                                  <b></b>
                                </StyledTableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {opt &&
                                opt.map((i) => (
                                  <StyledTableRow key={i.id}>
                                    <StyledTableCell>{i.name}</StyledTableCell>
                                    <StyledTableCell>
                                      <Button
                                        startIcon={<DeleteIcon color="error" />}
                                        onClick={() => {
                                          const url =
                                            process.env.REACT_APP_ZEWA_URL +
                                            "device/delete-device-name/" +
                                            i.id +
                                            "/";
                                          handleDelete(url);
                                        }}
                                      ></Button>
                                    </StyledTableCell>
                                  </StyledTableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </Box>
                  ) : (
                    <Box>
                      <FormControl fullWidth style={{ padding: "15px" }}>
                        <TextField
                          id="outlined-multiline-flexible"
                          label="Enter device group"
                          value={name}
                          onChange={(e) => {
                            setdevice_name(e.target.value);
                          }}
                        />
                        <Box>
                          <Button
                            color="primary"
                            variant="contained"
                            sx={buttonStyle2}
                            type="submit"
                            onClick={handleClick}
                          >
                            Add Group
                          </Button>
                          <Button
                            color="error"
                            variant="contained"
                            className="form__custom-button"
                            sx={buttonStyle}
                            type="submit"
                            onClick={() => {
                              setaddgroup(false);
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </FormControl>
                    </Box>
                  )}
                </Box>
              </TabPanel>
              <TabPanel value="4">
                Hub Token : dGhvbWFzQHpld2Fwb3J0YWxIdWI=
              </TabPanel>
            </TabContext>
          </Card>
        </Box>
        <NotificationContainer />
      </Root>
    </Root>
  );
}
